import React from 'react';
import { CardBody } from '@components/card/card';
import Select from 'react-select';

import { useAppDispatch } from '@store/hooks';
import { useFormik } from 'formik';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import NoData from '@components/NoData/NoData';
import {
  addAssetsAssignation,
  getAssetsAssignationList
} from '@store/Finance/FixedAssets/AssetsAssignation/assetsAssignationSlice';
import { useParams } from 'react-router-dom';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import useGetPersons from '@hooks/HR/use-get-persons';

const Assignation = () => {
  const dispatch = useAppDispatch();
  const { assetsId } = useParams();

  const { t, i18n } = useTranslation();

  const { dataEmployees } = useGetPersons();

  //#region Formik
  const formik = useFormik({
    initialValues: {
      faAssetsId: '',
      personId: '',
      startDate: '',
      description: ''
    },

    // enableReinitialize: true,
    // validationSchema: AddAssetsSchema(t),

    onSubmit: values => {
      dispatch(
        addAssetsAssignation({
          faAssetsId: assetsId,
          personId: values.personId,
          startDate: values.startDate,
          description: values.description
        })
      )
        .unwrap()
        .then(res => {
          // debugger;
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Add' });
            dispatch(getAssetsAssignationList());
            formik.resetForm();
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    }
  });
  const { values, handleChange, errors, touched, setFieldValue } = formik;
  //#endregion

  return (
    <>
      <div className='section mb-3'>
        <Form onSubmit={formik.handleSubmit}>
          <div className='row d-flex align-items-center'>
            <div className='col-lg-2'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('تاريخ التخصيـص')}</label>
                <Form.Control
                  autoComplete='off'
                  className='form-control'
                  type='date'
                  name='startDate'
                  onChange={handleChange}
                  value={values.startDate}
                />
                <div className='text-danger small'>{touched.startDate && errors.startDate}</div>
              </div>
            </div>

            <div className='col-lg-3'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('الموظف')}</label>
                <Select
                  classNamePrefix='react-select'
                  isSearchable={true}
                  isClearable
                  options={dataEmployees}
                  value={dataEmployees?.find((f: any) => f.value === formik.values.personId)}
                  onChange={(option: any) => {
                    formik.setFieldValue('personId', option?.value || null);
                  }}
                  placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                />
                <div className='text-danger small'>
                  {formik.touched.personId && formik.errors.personId}
                </div>
              </div>
            </div>

            <div className='col-lg-5'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('ملاحظـات')}</label>
                <Form.Control
                  autoComplete='off'
                  className='form-control'
                  type='text'
                  name='description'
                  onChange={handleChange}
                  value={values.description}
                />
              </div>
            </div>

            <div className='col-lg-2'>
              <button
                disabled={formik.isSubmitting}
                type='submit'
                className='btn btn-theme rounded-1 w-100 mt-3'
              >
                {formik.isSubmitting ? (
                  <div className='spinner-border spinner-border-sm me-2'></div>
                ) : (
                  <i className='fas fa-user-check fa-lg fa-fw me-2'></i>
                )}
                {t('تخصيص')}
              </button>
            </div>
          </div>
        </Form>
      </div>

      <div className='section mb-3'>
        <h6 className=''>
          <i className='fas fa-user-clock fa-lg fa-fw me-2 text-theme'></i>
          سجل تخصيصات الأصل
        </h6>

        <hr />
        <CardBody>
          <NoData />
        </CardBody>
      </div>
    </>
  );
};

export default Assignation;
